import React, { useEffect, useState } from "react";
import { MarketTableHeaderListItems, MarketTableHeaderLists } from "../styles";
import MarketTableTopHeader from "../MarketTableTopHeader";
import MarketTableTopHeaderTitle from "../MarketTableTopHeaderTitle";
import MarketTableHeaderListsItems from "../MarketTableHeaderListsItems";
import { loadData } from "@utils/api";
import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";

const MarketTableLeaderboard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    loadData().then((res) => {
      setData(res.slice(0, 3));
    });
  }, []);
  return (
    <MarketTableHeaderLists style={{ paddingInline: 10 }}>
      <MarketTableHeaderListItems>
        <MarketTableTopHeaderTitle title={t("leaderboard")} />
        <MarketTableTopHeader
          name={t("user")}
          amount={t("p&l")}
          rate={t("roi")}
        />
        {data.map((item, index) => (
          <MarketTableHeaderListsItems
            key={index.toString()}
            item={item}
            index={index}
            amountColor={COLORS.lightGreen}
            rateColor={COLORS.gray}
          />
        ))}
      </MarketTableHeaderListItems>
    </MarketTableHeaderLists>
  );
};

export default React.memo(MarketTableLeaderboard);
